export default __webpack_public_path__ + "images/de797878045c7f0e3e6d81cd3ab1964c196572ba4f3e73acc1566c04ecbe2074-SAJ_logo.svg";